import { z } from "zod/v4";

import {
  PatchStripeSubscriptionLinkDtoSchema,
  StripeSubscriptionLinkDtoSchema,
} from "../../../dtos/stripe-subscription-links";

export const GetStripeSubscriptionLinkByOrgIdPathParamsSchema = z.object({
  subscriptionLinkId: z.uuid(),
});

export type GetStripeSubscriptionLinkByOrgIdPathParamsType = z.infer<
  typeof GetStripeSubscriptionLinkByOrgIdPathParamsSchema
>;

export const GetStripeSubscriptionLinkByOrgIdResponseBodySchema = z.object({
  stripeSubscriptionLinks: StripeSubscriptionLinkDtoSchema.array(),
});

export type GetStripeSubscriptionLinkByOrgIdResponseBodyType = z.infer<
  typeof GetStripeSubscriptionLinkByOrgIdResponseBodySchema
>;
